import { Box, Typography, useTheme } from '@mui/material'
import { Gavel } from '@mui/icons-material'

interface LogoProps {
  variant?: 'sidebar' | 'header' | 'compact' | 'topbar'
  showText?: boolean
}

export default function Logo({ variant = 'sidebar', showText = true }: LogoProps) {
  const theme = useTheme()

  if (variant === 'compact' || variant === 'topbar') {
    const onDark = variant === 'topbar'
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: 2,
            bgcolor: onDark ? 'rgba(255,255,255,0.2)' : 'primary.main',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Gavel sx={{ color: 'white', fontSize: 24 }} />
        </Box>
        {showText && (
          <Typography variant="h6" sx={{ fontWeight: 700, color: onDark ? '#fff' : 'primary.main' }}>
            UEL E-Court
          </Typography>
        )}
      </Box>
    )
  }

  if (variant === 'header') {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: 1.5,
            bgcolor: 'primary.main',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Gavel sx={{ color: 'white', fontSize: 20 }} />
        </Box>
        {showText && (
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2, color: 'primary.main' }}>
              UEL E-Court
            </Typography>
            <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.7rem', fontWeight: 500 }}>
              Tòa án điện tử thực nghiệm
            </Typography>
          </Box>
        )}
      </Box>
    )
  }

  // Sidebar variant (default) – tone navy đồng bộ với toàn bộ sidebar
  return (
    <Box
      sx={{
        p: 2,
        bgcolor: 'transparent',
        color: 'rgba(255, 255, 255, 0.95)',
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: 2,
          bgcolor: 'rgba(255, 255, 255, 0.2)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <Gavel sx={{ fontSize: 24, color: 'white' }} />
      </Box>
      {showText && (
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 700,
              color: 'white',
              lineHeight: 1.2,
              fontSize: '0.95rem',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            UEL E-Court
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: 'rgba(255, 255, 255, 0.85)',
              fontWeight: 600,
              letterSpacing: 1,
              fontSize: '0.65rem',
              textTransform: 'uppercase',
            }}
          >
            Tòa án điện tử
          </Typography>
        </Box>
      )}
    </Box>
  )
}
